import React from 'react';
import { FormGroup, FormLabel, FormHint, FormError } from './form-group';
import { Input } from './input';
import { cn } from 'src/lib/utils';

const InputField = React.forwardRef(function InputField(
  { label, id, hint, error, className, ...inputProps },
  ref,
) {
  const inputId = id || `input-${Math.random().toString(36).slice(2, 9)}`;
  return (
    <FormGroup className={cn(className)}>
      {label && <FormLabel htmlFor={inputId}>{label}</FormLabel>}
      <Input ref={ref} id={inputId} error={!!error} {...inputProps} />
      {hint && !error && <FormHint>{hint}</FormHint>}
      {error && <FormError>{error}</FormError>}
    </FormGroup>
  );
});

export { InputField };
